module.exports = __webpack_public_path__ + "img/percayso.d3aa10d1.svg";